import { type FC } from 'react'

import type { DialogProps } from '@wartek-id/dialog-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'

interface DialogNoLongerDirectReportProps
  extends Omit<DialogProps, 'children'> {
  name: string
  onClick: () => void
}

import ImgFence from 'assets/icons/img-fence.svg'

const DialogNoLongerDirectReport: FC<DialogNoLongerDirectReportProps> = ({
  name,
  onClick = () => {},
  ...props
}) => {
  return (
    <Dialog autoFocus={false} {...props}>
      <DialogOverlay />
      <DialogContent className="!rounded-lg">
        <div className="p-6 space-y-2">
          <ImgFence width={120} height={120} />

          <Text variant="display-sm" className="!mt-4">
            {name} sudah konfirmasi bahwa Anda tidak lagi menjadi Tim Kinerjanya
          </Text>

          <Text variant="body-lg" color="subdued">
            Saat ini Anda tidak lagi memiliki akses. Pastikan data penunjukkan (
            <em>plotting</em>) Tim Kinerja di Simtendik sesuai dan mohon kabari
            Pejabat Penilai Kinerja terkait hal ini.
          </Text>

          <div className="flex gap-5 !mt-4">
            <Button size="lg" variant="ghost" color="blue" onClick={onClick}>
              Tutup
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DialogNoLongerDirectReport
